import axios from "axios";
import { urlDomain } from "../config/constant";

const apiDomain = urlDomain();

export const ticketIssue = (requestData) =>{
    const apiUrl = `${apiDomain}/ticketIssue`;
    return axios.post(apiUrl, requestData)
}

export const addOpportunity = (glid, empid, ak) => {
    const apiUrl = `${apiDomain}/addopportunity`;
    let currentDate = new Date();
    let expDate = new Date(currentDate.getTime() + (60 * 24 * 60 * 60 * 1000));
    // Format the expiration date
    let formattedExpDate = `${expDate.getDate()}-${getMonthName(expDate.getMonth())}-${expDate.getFullYear().toString().slice(-2)}`;

    // Function to get month name abbreviation
    function getMonthName(month) {
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        return months[month];
    }
    
    const requestData = {
        GLID: glid,
        createdby: empid,
        oppname: "Hot Lead",
        UpdatedbyScreen: "Contact Center CRM",
        opptype: 2,
        service: 318,
        stage: 26,
        expReiciptval: 53100,
        closuredate: `${formattedExpDate}`,
        dealamnt: 53100,
        AK: ak,
        desc: "Hot Lead created in SPANCO by Contact Center team"
    }

    return axios.post(apiUrl, requestData)
}